import { IMenu, IMenuItem } from "./abstract/imenu";

export class Menu implements IMenu {
  menus: IMenuItem[] = [
    {
      reference: "dashboard",
      title: "Início",
      icon: "las la-home",
      subMenus: [],
      url: "/dashboard"
    },
    {
      reference: "activities",
      title: "Atividades",
      icon: "las la-calendar-week",
      subMenus: [
        {
          title: "Painel de Atividades",
          icon: "las la-comments",
          url: "/activities/dashboard",
          subMenus: null
        },
        {
          title: "Calendário",
          icon: "las la-calendar-check",
          url: "/activities/calendar",
          subMenus: null
        }
      ]
    },
    {
      reference: "entities",
      title: "Pessoas",
      icon: "las la-users",
      subMenus: [
        {
          title: "Utilizadores",
          icon: "las la-user-friends",
          url: "/users",
          subMenus: null
        },
        {
          title: "Entidades",
          icon: "las la-users",
          url: "/entities",
          subMenus: null
        }
      ]
    },
//     $la-dochub: \f394;
// $la-docker: \f395;
    {
      title: "Inqueritos",
      icon: "las la-clipboard-check",
      subMenus: [
        {
          title: "Avaliações",
          icon: "las la-clipboard-check",
          url: "/feedback/surveys",
          subMenus: null
        },
        // {
        //   title: "Configurações",
        //   icon: "las la-sliders-h",
        //   url: "/feedback/configuration",
        //   subMenus: null
        // },
      ],
    },
    {
      reference: "configurations",
      title: "Configurações",
      icon: "las la-sliders-h",
      subMenus: [
        {
          title: "Grupos",
          icon: "las la-calendar-week",
          url: "/administration/groups",
          subMenus: null
        },
        {
          title: "Atividades",
          icon: "las la-calendar-week",
          url: "/activities/configurations",
          subMenus: null
        },
        {
          title: "Entidades",
          icon: "las la-users",
          url: "/entities/configurations",
          subMenus: null
        },
        {
          title: "Users",
          icon: "las la-users",
          url: "/users/configurations",
          subMenus: null
        },
        {
          title: "Feedback",
          icon: "las la-users",
          url: "/feedback/admin/configurations",
          subMenus: null
        },
        {
          title: "Atributos dinâmicos",
          icon: "las la-sitemap",
          url: "/administration/metadata",
          subMenus: null
        }
      ]
    },
    {
      reference: "help",
      title: "Ajuda",
      icon: "las la-question-circle",
      url: "/help",
      subMenus: []
    }
  ];
}

export class UserMenu implements IMenu {
  menus: IMenuItem[] = [
    {
      reference: "profile",
      title: "Perfil",
      icon: "las la-id-card-alt",
      subMenus: [],
      url: "/account/profile"
    },
    {
      reference: "security",
      title: "Segurança",
      icon: "las la-shield-alt",
      subMenus: [],
      url: "/account/security"
    }
    // {
    //   reference: "history",
    //   title: "Histórico",
    //   icon: "las la-history",
    //   subMenus: [],
    //   url: "/account/history"
    // }
  ];
}
